import Main from '@/features/pos/components/ProductConfigurationModal/Content/parts/Main'
import Provider from '@/features/pos/components/ProductConfigurationModal/form/Provider'
import { Actions, ProductVariant } from '@/features/pos/components/ProductConfigurationModal/types'
import { getDefaultProductVariant } from '@/features/pos/components/ProductConfigurationModal/utils/getDefaultProductVariant'
import { FC } from 'react'

type ContentProps = {
    productName?: string
    productVariants?: ProductVariant[]
    defaultProductVariantId?: string
    defaultQuantity?: number
    allowQuantityChange?: boolean
} & Actions

const Content: FC<ContentProps> = ({
    productName,
    productVariants,
    defaultProductVariantId,
    defaultQuantity,
    allowQuantityChange,
    onConfirm,
    onCancel,
    cancelLabel,
}) => {
    return (
        <Provider
            productVariant={getDefaultProductVariant(productVariants, defaultProductVariantId)}
            defaultQuantity={defaultQuantity}
        >
            <Main
                productName={productName}
                productVariants={productVariants}
                allowQuantityChange={allowQuantityChange}
                onConfirm={onConfirm}
                onCancel={onCancel}
                cancelLabel={cancelLabel}
            />
        </Provider>
    )
}

export default Content
